export const AUTH_TOKEN_KEY = 'token';
export const AUTH_REF_TOKEN_KEY = 'refreshToken';
export const AUTH_ADMIN_TOKEN_KEY = 'admin_token';
export const AUTH_ADMIN_REF_TOKEN_KEY = 'admin_refreshToken';

export enum EAuthMethod {
  COOKIE = 'COOKIE',
  TOKEN = 'TOKEN',
}
